





















import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class DialogCloseNavigation extends Vue {

  @Prop({ default: false }) light: boolean;
  @Prop({ default: '30px' }) marginTop: string;
  @Prop({ default: false }) fixedBottom: boolean;

  @Emit('close')
  private onClose (): void {}

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

}
